export default [
  {
    title: "แผนประกันการเดินทางระหว่างประเทศ (รายเดี่ยว) - Eco",
    link: require("../../../static/pdf-template/taSawasdee/Single_Eco.pdf"),
    file_name: "ใบสมัครประกันเดินทางต่างประเทศ.pdf.pdf"
  },
  {
    title: "แผนประกันการเดินทางระหว่างประเทศ (รายเดี่ยว) - Eco Plus",
    link: require("../../../static/pdf-template/taSawasdee/Single_Eco_Plus.pdf"),
    file_name: "ใบสมัครประกันเดินทางต่างในประเทศ.pdf"
  },
  {
    title: "แผนประกันการเดินทางระหว่างประเทศ (รายเดี่ยว) - Good",
    link: require("../../../static/pdf-template/taSawasdee/Single_Good.pdf"),
    file_name: "ใบสมัครประกันเดินทางต่างในประเทศ.pdf"
  },
]